import React , { useState, useEffect } from 'react';
import './App.css';
import PWASetpsAndroid from './component/PWASetpsAndroid';
import PWASetpsIos from './component/PWASetpsIos';
import config from './component/config';
import { isDesktop } from "react-device-detect";
// import ThemeTopMenuDrawer from './component/ThemeTopMenuDrawer';
//import SplashSlider from './component/SplashSlider';
import AppScreen from './component/AppScreen';
import QRCodeGenerator from './component/QRCodeGenerator';
import { Button, Card, CardContent } from '@material-ui/core';
import { Gift, Smartphone, MessageCircle, QrCode, CheckCircle, AlertCircle } from 'lucide-react';
import WebTour, { defaultStepStyle as stepStyle } from './component/webTour/WebTour';
import MobileRedirectPage from './component/MobileRedirectPage';

const homeTourSteps = [
  {
    selector: '.free-gifts .category-container',
    content: 'Shop Curated New Age Brands on best Discounts up here.',
    style: stepStyle
  },
   {
    selector: '.userNavigation .searchFormToggleFixed',
    content: 'Check wallet for Cashback, gifted or earned by you.',
    style: stepStyle
  },
  {
    selector: '#category_54 .category-container',
    content: 'Redeem any Brand Vouchers with your Cashback. pay any balance with cash.',
    style: stepStyle
  },
  {
    selector: '#category_0 .category-container',
    content: 'Redeem any Brand store Vouchers that will work in Offline Stores nearby. pay any balance  with cash.',
    style: stepStyle
  },
 
];

function App() {

  /* Check is browser or pwa */
  let displayMode = 'browser';
  const mqStandAlone = '(display-mode: standalone)';
  if (navigator.standalone || window.matchMedia(mqStandAlone).matches) {
    displayMode = 'standalone';
  }

  /* is ios or android */
  const ua = window.navigator.userAgent;
  const webkit = !!ua.match(/WebKit/i);
  const isIPad = !!ua.match(/iPad/i);
  const isIPhone = !!ua.match(/iPhone/i)
  const isIOS = isIPad || isIPhone;

  var currentUrl = window.location.href;
  var spiltArray = currentUrl.split('/publisher/');
  var deviceOpen = 'web';
  if (spiltArray[1] !== undefined) {
    var providerInfo = spiltArray[1].split('/?');
    if (providerInfo[1] === undefined) {
      providerInfo = spiltArray[1].split('/');
    }

    if (providerInfo[1] !== undefined && providerInfo[1] !== "") {
      /* Ignore Storage for Demo Promo */
      var search = providerInfo[1];
      // var userInfo = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');
      const rawParams = providerInfo[1].replace("?", "").split("&");
      const userInfo = {};
      rawParams.forEach((item) => {
        item = item.split("=");
        userInfo[item[0]] = item[1];
      });
      console.log(userInfo.fiDeviceType);
      if (userInfo.fiDeviceType !== undefined) {
        deviceOpen = userInfo.fiDeviceType;
      }
    }
  }

  /* Ignore on app open */
  var currentUrl = window.location.href;
  var spiltArray = currentUrl.split('/publisher/');
  if (spiltArray[1] !== undefined || localStorage.getItem('OpenPWAUserPromo') !== null) {
    displayMode = 'miniApp';
  }
  var NoDataFound = config.getProviderSetting().fsNoData;

  const userInfo = {};
  const email = userInfo.fsEmail || '';
 const urlParams = new URLSearchParams(window.location.search);

let fsDialCode = urlParams.get("fsDialCode") || '';
fsDialCode = decodeURIComponent(fsDialCode); 
const fsMobile = urlParams.get("fsMobile") || '';
const fullPhone = fsDialCode + fsMobile;

  const referralUrl = window.location.origin + window.location.pathname + window.location.search;

   const [statusMessage, setStatusMessage] = useState('');
  const [showHomeTour, setShowHomeTour] = useState(false);

  useEffect(() => {
    const TOUR_KEY = 'hasSeenHomeTour';
    if (localStorage.getItem(TOUR_KEY) === 'true') {
      return;
    }
   
    const interval = setInterval(() => {
       if (localStorage.getItem(TOUR_KEY) === 'false') {
        setShowHomeTour(true);
        localStorage.setItem(TOUR_KEY,'true');
        return;
      }
    }, 500);
    return () => clearInterval(interval);
  }, []);

  const sendReferral = (method) => {
  if (!fullPhone) {
    setStatusMessage("Phone number is not added on link.");
    return;
  }

  // Handle email separately
  if (method === 'email') {
    const to = config.fsSupportEmail();
   
    const subject = encodeURIComponent("Your Referral Link");
    const body = encodeURIComponent(
      `Hi,\n\nThis is your referral link:\n${referralUrl}\n\nFrom,\n`
    );
    window.location.href = `mailto:${to}?subject=${subject}&body=${body}`;
    return;
  }

  const requestParams = {
    fsAction: "sendReferralLink",
    fsDialCode,
    fsMobile,
    fsLink: referralUrl,
    fsSendBy: method === 'whatsapp' ? 'whatsapp' : '',
    fsDeviceId: "bc7434c3555f12bab1-1749555717524"
  };

  setStatusMessage("Sending...");

  // ✅ Use the shared fetchInformation abstraction
  config.fetchInformation(requestParams)
    .then((data) => {
      if (data.fbIsError) {
        setStatusMessage("Failed to send referral link.");
      } else {
        if (method === 'whatsapp' && data.fbWhatsappSent) {
          setStatusMessage("WhatsApp message sent successfully.");
        } else if (method === 'email' && data.fbEmailSent) {
          setStatusMessage("Email sent successfully.");
        } else {
          setStatusMessage("Referral sent but no confirmation received.");
        }
      }
    })
    .catch((err) => {
      console.error("Send error:", err);
      setStatusMessage("Error sending referral link.");
    });
};

  if (isDesktop) {
    return (

      <MobileRedirectPage
        referralUrl={referralUrl}
        sendReferral={sendReferral}
        statusMessage={statusMessage}
        QRCodeGenerator={QRCodeGenerator}
      />

  //   <div
  //       style={{
  //         minHeight: "100vh",
  //         background: "linear-gradient(135deg, #7f838b, #7d8085)",
  //         display: "flex",
  //         alignItems: "center",
  //         justifyContent: "center",
  //         padding: "40px 16px",
  //         fontFamily: "'Segoe UI', sans-serif",
  //       }}
  //     >
  //       <div
  //         style={{
  //           backgroundColor: "#fff",
  //           borderRadius: "12px",
  //           padding: "32px 24px",
  //           maxWidth: "500px",
  //           width: "100%",
  //           textAlign: "center",
  //           boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
  //         }}
  //       >
  //         {/* Icon Header */}
  //         <div style={{ marginBottom: "24px" }}>
  //           <div
  //             style={{
  //               width: "80px",
  //               height: "80px",
  //               backgroundColor: "#ffedd5",
  //               borderRadius: "50%",
  //               display: "flex",
  //               alignItems: "center",
  //               justifyContent: "center",
  //               margin: "0 auto 16px auto",
  //             }}
  //           >
  //             <Gift size={40} color="#f97316" />
  //           </div>
  //           <h2
  //             style={{
  //               fontSize: "20px",
  //               fontWeight: 700,
  //               marginBottom: "8px",
  //               color: "#1f2937",
  //             }}
  //           >
  //             Our Gifting Only Works From Mobile
  //           </h2>
           
  //         </div>

  //         {/* QR Code */}
  //         <div style={{ marginBottom: "16px" }}>
  //           <div
  //             style={{
  //               padding: "8px",
  //               backgroundColor: "#fff",
  //               borderRadius: "8px",
  //               boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
  //               display: "inline-block",
  //             }}
  //           >
  //             <QRCodeGenerator value={referralUrl} size={160} />
  //           </div>
  //           <div
  //             style={{
  //               display: "flex",
  //               alignItems: "center",
  //               justifyContent: "center",
  //               gap: "6px",
  //               marginTop: "10px",
  //               fontSize: "13px",
  //               color: "#4b5563",
  //             }}
  //           >
  //             <QrCode size={16} />
  //             <span>Scan QR code above with mobile</span>
  //           </div>
  //         </div>

  //         {/* WhatsApp Link */}
  //         <div style={{ marginBottom: "24px" }}>
  //           <div
  //             style={{
  //               display: "flex",
  //               alignItems: "center",
  //               justifyContent: "center",
  //               gap: "6px",
  //               marginBottom: "12px",
  //               fontWeight: 600,
  //               color: "#374151",
  //               fontSize: "14px",
  //               marginTop:"35px"
  //             }}
  //           >
  //             <Smartphone size={18} />
  //             <span>Receive a link on your WhatsApp</span>
  //           </div>

  //          <button
  //   style={{
  //     backgroundColor: "#25D366",
  //     color: "#fff",
  //     fontWeight: "600",
  //     padding: "10px 16px",
  //     borderRadius: "8px",
  //     border: "none",
  //     cursor: "pointer",
  //     fontSize: "14px",
  //     display: "inline-flex",
  //     alignItems: "center",
  //     justifyContent: "center",
  //     gap: "6px",
  //     width: "100%",
  //   }}
  //   onClick={() => sendReferral('whatsapp')}
  // >
  //   <MessageCircle size={16} />
  //   Send on WhatsApp
  // </button>
  //         </div>

  //         {/* Status Message */}
  //         {statusMessage && (
  //           <div style={{ marginBottom: "20px" }}>
  //             <div
  //               style={{
  //                 padding: "10px",
  //                 borderRadius: "8px",
  //                 fontSize: "13px",
  //                 fontWeight: "500",
  //                 display: "flex",
  //                 alignItems: "center",
  //                 justifyContent: "center",
  //                 gap: "8px",
  //                 color: statusMessage.includes("successfully")
  //                   ? "#15803d"
  //                   : statusMessage.includes("Failed") ||
  //                     statusMessage.includes("required")
  //                   ? "#b91c1c"
  //                   : "#1d4ed8",
  //                 backgroundColor: statusMessage.includes("successfully")
  //                   ? "#dcfce7"
  //                   : statusMessage.includes("Failed") ||
  //                     statusMessage.includes("required")
  //                   ? "#fee2e2"
  //                   : "#dbeafe",
  //                 border: `1px solid ${
  //                   statusMessage.includes("successfully")
  //                     ? "#86efac"
  //                     : statusMessage.includes("Failed") ||
  //                       statusMessage.includes("required")
  //                     ? "#fca5a5"
  //                     : "#93c5fd"
  //                 }`,
  //               }}
  //             >
  //               {statusMessage.includes("successfully") ? (
  //                 <CheckCircle size={16} />
  //               ) : statusMessage.includes("Failed") ||
  //                 statusMessage.includes("required") ? (
  //                 <AlertCircle size={16} />
  //               ) : (
  //                 <div
  //                   style={{
  //                     width: "16px",
  //                     height: "16px",
  //                     border: "2px solid #3b82f6",
  //                     borderTopColor: "transparent",
  //                     borderRadius: "50%",
  //                     animation: "spin 1s linear infinite",
  //                   }}
  //                 />
  //               )}
  //               {statusMessage}
  //             </div>
  //           </div>
  //         )}

  //         {/* Info Footer */}
  //         <div
  //           style={{
  //             fontSize: "12px",
  //             color: "#6b7280",
  //             backgroundColor: "#f9fafb",
  //             padding: "12px",
  //             borderRadius: "8px",
  //             lineHeight: "1.5",
  //           }}
  //         >
  //           <p style={{ marginBottom: "4px" }}>
  //             <span role="img" aria-label="bulb">
  //               💡
  //             </span>{" "}
  //             <strong>Why mobile only?</strong>
  //           </p>
  //           <p>
  //             Our gifting experience is optimized for mobile devices to ensure the
  //             best user experience and easy access for future rewards & cashbacks.
  //           </p>
  //         </div>
  //       </div>
  //     </div>
    
    )
  }

  // if(displayMode==='browser' && config.isProd && deviceOpen==='web'){
  //   var checkData = "";
  //   var android = <div className="android">
  //       <PWASetpsAndroid/>
  //   </div>;

  //   var ios = <div className="ios">
  //      <PWASetpsIos/>
  //     </div>;

  //   if(isIOS){
  //     checkData = ios;
  //   }else{
  //     checkData = android;
  //   }

  //   if(config.isOnline===false){
  //     checkData = <div className="spashScreen">
  //         <div className="whiteBg">
  //             <div className="AppLoginScreen">
  //                 <div className="NoDataFound">
  //                     <img style={{'marginTop':'0'}} src={NoDataFound} alt="No Data Found"/>
  //                     <div>Oops!</div>
  //                     <div>You're offline right now. Check your internet connection.</div>
  //                 </div>
  //             </div>
  //         </div>
  //     </div>
  //   }

  //   return (
  //     <div className="App">
  //         <div className="spashSliderPWA">
  //             <div className="information">
  //                 {checkData}
  //             </div>
  //         </div>
  //     </div>
  //   )
  // }

  return (
    <div className="App">
      {showHomeTour && <WebTour steps={homeTourSteps} />}
      <AppScreen />
    </div>
  );
}

export default App;
